export default __webpack_public_path__ + "src/assets/icn-cant-reverse.9938707f39c8290b8b3f175bf83ad937.svg";